<template>
    <v-text-field
        v-on="$listeners"
        v-bind="$attrs"
        :label="labelComputed"
        dense
        outlined
        @focus="pickerCallback"
    />
</template>

<script>
import RequiredField from "../../Mixins/RequiredField";

export default {
    name: "TextField",

    mixins: [RequiredField],

    props: {
        showPicker: { default: false, type: Boolean },
    },

    methods: {
        pickerCallback(event) {
            if (!this.showPicker) {
                return;
            }

            try {
                event.target.showPicker();
            } catch (e) {
                //
            }
        },
    },
};
</script>
